var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './DenyComments.module.scss';
import DateTimeService from '@app/Services/DateTimeService';
var DenyComments = /** @class */ (function (_super) {
    __extends(DenyComments, _super);
    function DenyComments() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DenyComments.prototype.render = function () {
        var denyComments = this.props.denyComments;
        return (React.createElement(React.Fragment, null, denyComments.map(function (x, i) {
            return (React.createElement("div", { className: styles.item, key: 'denyComments' + i },
                React.createElement("span", { className: styles.date }, DateTimeService.toUiDate(x.date)),
                React.createElement("span", { className: styles.name }, x.principalName),
                React.createElement("span", { className: styles.comment }, x.comment)));
        })));
    };
    return DenyComments;
}(React.PureComponent));
export { DenyComments };
